var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 8.95334C9.14877 8.95334 10.08 8.02209 10.08 6.87334C10.08 5.72458 9.14877 4.79333 8.00001 4.79333C6.85126 4.79333 5.92001 5.72458 5.92001 6.87334C5.92001 8.02209 6.85126 8.95334 8.00001 8.95334Z",
    stroke: "#7D7E7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41333 5.66004C3.72667 -0.113291 12.28 -0.106624 13.5867 5.66671C14.3533 9.05338 12.2467 11.92 10.4 13.6934C9.06 14.9867 6.94 14.9867 5.59333 13.6934C3.75333 11.92 1.64667 9.04671 2.41333 5.66004Z",
    stroke: "#7D7E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.44c8d9d1dc8e4d898a749e50de9804f7.svg";
export { ForwardRef as ReactComponent };